import React, { ReactNode, Children, isValidElement } from 'react';

interface DetailSectionProps {
    title: string;
    children: ReactNode;
}

export const DetailSection: React.FC<DetailSectionProps> = ({ title, children }) => {
    const childrenArray = Children.toArray(children);

    const visibleChildren = childrenArray.filter(child => {
        if (isValidElement(child) && child.type === DetailItem) {
            const { value } = child.props;
            return value !== undefined && value !== null && value !== '';
        }
        return true;
    });

    if (visibleChildren.length === 0) return <></>;

    return (
        <div className="border-b border-gray-200 pb-4 mb-4">
            <h3 className="text-lg font-bold mb-3">{title}</h3>
            <div className="flex flex-col gap-y-2">
                {children}
            </div>
        </div>
    );
};

export const DetailItem: React.FC<{ label: string; value: string | number | null | undefined }> = ({
                                                                                                       label,
                                                                                                       value
                                                                                                   }) => {
    if (value === undefined || value === null || value === '') return <></>;

    return (
        <div className="flex justify-between items-center align-self-stretch">
            <span className="text-sm text-gray-500">{label}</span>
            <span className="font-medium">{value.toString()}</span>
        </div>
    );
};
